import  gql  from 'graphql-tag'

export const SHARE_AGROMICROWORKSHEET_EMAIL = gql`mutation shareAgroMicroWorksheetByEmail($input: ShareAgroMicroWorksheetByEmailMutationInput!){
    shareAgroMicroWorksheetByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;